import { render } from "./searchBarComponent.vue?vue&type=template&id=0e97c224&scoped=true"
import script from "./searchBarComponent.vue?vue&type=script&lang=js"
export * from "./searchBarComponent.vue?vue&type=script&lang=js"

import "./searchBarComponent.vue?vue&type=style&index=0&id=0e97c224&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e97c224"]])

export default __exports__